import PropTypes from "prop-types"



export function PaginationTable({
	page,
	pageSize,
	setPage,
	totalItems,
	totalText,
}) {
	const totalAvailablePages = Math.ceil(totalItems / pageSize)

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalAvailablePages) {
			setPage(newPage)
		}
	}

	const generatePageButtons = () => {
		const buttons = []
		let startPage = Math.max(1, page - 2)
		let endPage = Math.min(totalAvailablePages, page + 2)

		if (endPage - startPage < 4 && totalAvailablePages > 4) {
			if (startPage === 1) {
				endPage = Math.min(5, totalAvailablePages)
			} else if (endPage === totalAvailablePages) {
				startPage = Math.max(1, totalAvailablePages - 4)
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			buttons.push(
				<button
					key={i}
					onClick={() => handlePageChange(i)}
					style={{
						width: "36px",
						height: "36px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: i === page ? "#ff8000" : "white",
						color: i === page ? "white" : "#666",
						border: "1px solid #ddd",
						borderRadius: "0",
						cursor: "pointer",
						fontWeight: i === page ? "bold" : "normal",
					}}
				>
					{i}
				</button>
			)
		}

		return buttons
	}

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				backgroundColor: "white",
				borderRadius: "8px",
				padding: "8px 16px",
				marginTop: "16px",
			}}
		>
			<span>{`${totalText || 'Total'}: ${totalItems}`}</span>
			<div style={{ display: "flex", alignItems: "center" }}>
				<button
					onClick={() => handlePageChange(page - 1)}
					disabled={page === 1}
					style={{
						width: "36px",
						height: "36px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "white",
						color: page === 1 ? "#ccc" : "#666",
						border: "1px solid #ddd",
						borderRadius: "0",
						cursor: page === 1 ? "not-allowed" : "pointer",
					}}
				>
					&lt;
				</button>

				{generatePageButtons()}

				<button
					onClick={() => handlePageChange(page + 1)}
					disabled={page === totalAvailablePages}
					style={{
						width: "36px",
						height: "36px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "white",
						color: page === totalAvailablePages ? "#ccc" : "#666",
						border: "1px solid #ddd",
						borderRadius: "0",
						cursor: page === totalAvailablePages ? "not-allowed" : "pointer",
					}}
				>
					&gt;
				</button>

				<button
					onClick={() => handlePageChange(totalAvailablePages)}
					disabled={page === totalAvailablePages}
					style={{
						width: "36px",
						height: "36px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "white",
						color: page === totalAvailablePages ? "#ccc" : "#666",
						border: "1px solid #ddd",
						borderRadius: "0",
						cursor: page === totalAvailablePages ? "not-allowed" : "pointer",
					}}
				>
					&gt;&gt;
				</button>
			</div>
		</div>
	)
}

PaginationTable.propTypes = {
	page: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	setPage: PropTypes.func.isRequired,
	totalItems: PropTypes.number.isRequired,
	totalText: PropTypes.string,
}
